import { getEnergyForecastAvailabilityV2 } from "@/api/hooks/micro-service/EnergyForecast";
import type { EnsembleModelInfo, StandardModelInfo } from "@mm/energy.metx.meteomatics.com";
import { createSlice } from "@reduxjs/toolkit";

export type EnergyForecastState = {
  availability?: {
    [key: string]: {
      [key: string]: EnsembleModelInfo | StandardModelInfo;
    };
  };
  isLoading: boolean;
};

const initialState: EnergyForecastState = {
  isLoading: false,
};

const energyForecastSlice = createSlice({
  name: "account",
  initialState: initialState as EnergyForecastState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEnergyForecastAvailabilityV2.pending, (state, _action) => {
      state.isLoading = true;
    });
    builder.addCase(getEnergyForecastAvailabilityV2.fulfilled, (state, action) => {
      state.availability = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getEnergyForecastAvailabilityV2.rejected, (state, _action) => {
      state.isLoading = false;
    });
  },
});

export default energyForecastSlice.reducer;
